import { atom } from 'recoil';

export const formMetadataState = atom({
	key: 'formMetadataState',
	default: {
		id: null,
		url: null,
		name: null,
		description: null,
		useGeolocation: null,
		useCaptcha: null,
		useGeofence: null,
		iconName: null,
		primaryColor: null,
		secondaryColor: null,
		sysAppname: null,
		useRateLimiting: 0,
		inputs: [],
	},
});
